const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function startVersionPolling() {
  const currentVersion = __APP_VERSION__;

  if (currentVersion === 'dev') return; // skip in local dev
//   console.info(`Current app version: ${currentVersion}. Starting version polling every ${CHECK_INTERVAL / 60000} minutes.`);

  const check = async () => {
    try {
      const res = await fetch('/version.json', { cache: 'no-store' });
      const { version } = await res.json();
      if (version && version !== currentVersion) {
        window.location.reload();
      }
    } catch {
      // ignore — offline, network error, etc.
    }
  };

  setInterval(check, CHECK_INTERVAL);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
}
const STALE_CHUNK_RELOAD_KEY = 'staleChunkReloadAt';

// A deploy deletes the old hashed chunks, so lazy imports in an already-open tab 404; reload to get the new build.
export function reloadOnStaleChunk() {
  window.addEventListener('vite:preloadError', (event) => {
    try {
      const lastReload = Number(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY));
      // Guard against a reload loop if the chunk is genuinely missing.
      if (Date.now() - lastReload < 10_000) return;
      sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(Date.now()));
    } catch {
      // sessionStorage unavailable — still reload once.
    }
    event.preventDefault();
    window.location.reload();
  });
}
